import axios from 'axios';
import { apiConfig } from '@/utils/config';
import { getFingerprint } from './fingerprint';
import { decryptData } from '@/utils/crypto';
// Create an Axios instance
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL || apiConfig.baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add fingerprint
apiClient.interceptors.request.use(async (config) => {
  try {
    const fingerprint = await getFingerprint();
    if (fingerprint) {
      config.headers['X-FP-EM'] = fingerprint;
    }
    return config;
  } catch (error) {
    console.error('Failed to get fingerprint:', error);
    return config;
  }
});

// Interceptor to handle retries
apiClient.interceptors.response.use(
  response => response, // Return the response if successful
  async error => {
    const config = error.config;
    if (!config || !config.retry || error.response?.status === 503) return Promise.reject(error);

    config.__retryCount = config.__retryCount || 0;

    if (config.__retryCount >= config.retry) {
      // Reject with the error after exhausting retries
      return Promise.reject(error);
    }

    config.__retryCount += 1;

    // Optional: Add delay between retries
    const delay = new Promise(resolve => setTimeout(resolve, config.retryDelay || 1000));

    await delay;

    // Retry the request
    return apiClient(config);
  }
);

// Centralized methods for HTTP requests
const apiService = {
  get(endpoint, params = {}, requiresAuth = true, retry = 3, retryDelay = 1000) {
    const config = {
      params,
      retry,
      retryDelay,
      headers: {},
    };

    if (requiresAuth) {
      const token = decryptData(localStorage.getItem('token'));
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return apiClient.get(endpoint, config);
  },

  post(endpoint, data, requiresAuth = true, config = {}) {
    config.retry = config.retry || 3;
    config.retryDelay = config.retryDelay || 1000;

    if (requiresAuth) {
     const token = decryptData(localStorage.getItem('token'));
      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        };
      }
    }

    return apiClient.post(endpoint, data, config);
  },

  put(endpoint, data, requiresAuth = true, config = {}) {
    config.retry = config.retry || 3;
    config.retryDelay = config.retryDelay || 1000;

    if (requiresAuth) {
    const token = decryptData(localStorage.getItem('token'));
      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        };
      }
    }

    return apiClient.put(endpoint, data, config);
  },

  delete(endpoint, requiresAuth = true, config = {}) {
    config.retry = config.retry || 3;
    config.retryDelay = config.retryDelay || 1000;

    if (requiresAuth) {
     const token = decryptData(localStorage.getItem('token'));
      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
          "Cookie": document.cookie
        };
      }
    }

    return apiClient.delete(endpoint, config);
  },
};

export default apiService;
